export default __webpack_public_path__ + "static/media/contact_back.0e82e7e2.jpg";